import { SxProps, TableCell, Theme, Tooltip } from '@mui/material'
import {
  useGetJobsLiveList,
  useGetPhasesLiveList,
} from '@/services/hooks/relay/live-lists'
import { useDocumentContext } from '@/components/image-zoom-pan/providers/DocumentProvider'
import { useProjectContext } from '@/components/project-tables/ProjectProvider'

type NumberCellProps = {
  num: string | null | undefined
  displayName?: string
  jobNumber?: string | null
  sx?: SxProps<Theme>
}

type BaseNumberCellProps = {
  num: string | null | undefined
  resolvedName: string | null | undefined
  sx?: SxProps<Theme>
}

function NumberCell({
  num,
  resolvedName,
  sx = { py: 0.5 },
}: BaseNumberCellProps) {
  return (
    <Tooltip
      title={resolvedName || ''}
      disableHoverListener={!resolvedName}
      enterDelay={200}
      disableInteractive
      arrow
      placement="top"
    >
      <TableCell sx={sx}>{num || '—'}</TableCell>
    </Tooltip>
  )
}

export function JobNumberCell({ num, displayName, sx }: NumberCellProps) {
  const { document } = useDocumentContext()
  const { project } = useProjectContext()
  const orgId = document?.owner_org_id || ''
  const orgCredentialTypeId = project.org_credential_type_id || ''
  const { jobs } = useGetJobsLiveList({
    orgId: orgId || '',
    orgCredentialTypeId: orgCredentialTypeId || '',
    filters: num ? { num__eq: num } : undefined,
    enabled: !displayName && !!num,
  })
  const resolvedName = displayName || jobs[0]?.pd_display_name

  return <NumberCell num={num} resolvedName={resolvedName} sx={sx} />
}

export function PhaseNumberCell({
  num,
  displayName,
  jobNumber,
  sx,
}: NumberCellProps) {
  const { document } = useDocumentContext()
  const { project } = useProjectContext()
  const orgId = document?.owner_org_id || ''
  const orgCredentialTypeId = project.org_credential_type_id || ''

  const { phases } = useGetPhasesLiveList({
    orgId,
    orgCredentialTypeId,
    jobNum: jobNumber || '',
    filters: num ? { num__eq: num } : undefined,
    enabled: !displayName && !!num,
  })
  const resolvedName = displayName || phases[0]?.pd_display_name

  return <NumberCell num={num} resolvedName={resolvedName} sx={sx} />
}
